import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { get } from 'ctm-util-functions';

import { ErrorMessage } from './error_message';
import { SimpleFlexbox } from '../flexbox/flexbox';

import styles from './error.css';

class _InternalError extends Component {

    /**
     * Return an error trace that you can view on the frontend, only in development though.
     * @returns {Node} A Flexbox Component
     */
    getErrorTrace = () => {
        const error = get(this.props, 'error.stack');
        return error && process.env.NODE_ENV === 'development' ? (
            <SimpleFlexbox xs={10} xsOffset={1}>
                <h3>Error Traceback</h3>
                <pre className={styles.json_pre}>
                    <code>
                        {error}
                    </code>
                </pre>
            </SimpleFlexbox>
        ) : null;
    };

    /**
     * Render the modal's child flebox
     * @returns {Node} The internal error modal content
     */
    render = () => {
        const { error, dispatch } = this.props;
        return (
            <>
                <ErrorMessage error={error} dispatch={dispatch} />
                {this.getErrorTrace()}
            </>
        );
    };

}

_InternalError.propTypes = {
    dispatch: PropTypes.func.isRequired,
    error: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
    return {
        error: state.getIn(['error', 'internalError'])
    };
};

const InternalError = connect(mapStateToProps)(_InternalError);

export { _InternalError, InternalError };
